import { Component, OnInit } from '@angular/core';
import { Summary, Summary_Types, TabDetails } from '../../../interfaces/summary.interface';
import { FileTypes } from '../../../interfaces/referral.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedReusableComponent } from '../shared-reusable/shared-reusable-component.component';
import { CollaborationService } from '../../../services/collaboration.service';
import { SCREEN_TYPES } from '../../../interfaces/shared.interface';
import { SharedNotificationSettingsComponent } from '../shared-notification-settings/shared-notification-settings.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { UserThumbNailComponent } from '../../../components/user-thumb-nail/user-thumb-nail.component';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { DatePipe } from '@angular/common';
import { AssetUrlPipe } from '../../../pipes/asset-url.pipe';

@Component({
    selector: 'app-shared-collaboration-summary',
    templateUrl: './shared-collaboration-summary.component.html',
    styleUrl: './shared-collaboration-summary.component.scss',
    imports: [SharedNotificationSettingsComponent, MatProgressSpinner, MatTooltip, FormsModule, MatTabGroup, MatTab, InfiniteScrollDirective, UserThumbNailComponent, SpinnerComponent, DatePipe, AssetUrlPipe]
})
export class SharedCollaborationSummaryComponent extends SharedReusableComponent implements OnInit {
  searchText: any;
  tabLabels: string[] = ['@ mentions', 'everything', 'posts', 'files', 'comments'];
  summaryData: TabDetails[] = [];
  selectedTabIndex: number = 1;
  filteredSummaryData: any;
  labelTypeMatcher: any = {
    '@ mentions': Summary_Types.MENTION,
    'posts': Summary_Types.POST,
    'files': Summary_Types.FILE,
    'comments': Summary_Types.COMMENT
  };
  showOnDemandLoader = false;
  iconUrlMapper: any = {
    post: 'forum',
    comment: 'comment_lime',
    docx: "word_file",
    pptx: "ppt_file",
    xlsx: "excel_file",
    xlsb: "excel_file",
    xlsm: "excel_file",
    note: "file_document",
    pdf: "pdf",
    zip: "zip",
    eml: "email",
    png: "image_png",
    jpg: "image_png",
    svg: "image_png",
    txt: "text_grey",
    folder: "folder",
  };
  isUserUnAuthorized = false;
  errorStatusCode;
  isSummaryDataLoaded = false;
  maxRecordsInOneAPIRes = 100;
  screenType: SCREEN_TYPES = SCREEN_TYPES.TASK_SUMMARY;
  searchMsg: string = `with selected search criteria. Please try with
  different text.`;

  constructor(override collaborationService: CollaborationService,
    public sanitizer: DomSanitizer) {
    super(collaborationService);
  }
  override ngOnInit() {
    this.showLoader = true;
    super.ngOnInit();
  }

  override initialize(): void {
    if (this.sharedData?.isOnDemandScrollResponse) {
      if (this.sharedData?.onDemandScrollResponse?.type === 'error') {
        this.showOnDemandLoader = false;
        this.isSummaryDataLoaded = true;
        if (this.sharedData?.fromSearchTetx) {
          this.summaryData[this.sharedData?.selectedTabIndex].searchTextData = this.summaryData[this.sharedData?.selectedTabIndex].oldSearchText;
        }
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(this.sharedData?.onDemandScrollResponse?.err, 'Error while retrieving summery data. Please try after some time.');
        return;
      }
      this.showLoader = false;
      this.showOnDemandLoader = false;
      this.isSummaryDataLoaded = true;
      let tabData = this.summaryData[this.sharedData?.selectedTabIndex];
      const methodToCall = tabData.method.bind(this);
      tabData = {
        ...tabData,
        data: this.sharedData?.resetData ? methodToCall(this.sharedData?.onDemandScrollResponse) : [...tabData.data, ...methodToCall(this.sharedData?.onDemandScrollResponse)],
        isAllDataLoaded: this.sharedData?.onDemandScrollResponse?.length < this.maxRecordsInOneAPIRes ? true : false
      }
      this.summaryData[this.sharedData?.selectedTabIndex] = tabData;
      this.filteredSummaryData = tabData.data;
      return;
    }
    if (this.sharedData?.summaryData?.type === 'error') {
      this.summaryData = [];
      this.collaborationService.displayErrorMessage(this.sharedData?.summaryData?.err, 'Error while retrieving summery data. Please try after some time.');
      this.showLoader = false;
    }
    else {
      this.summaryData = this.initSummaryData();
      this.tabChanged();
      this.showLoader = false;
    }
    this.isSummaryDataLoaded = true;
  }

  initSummaryData() {
    return [
      {
        name: "@ mentions",
        tabName: 'mentions',
        data: this.updateRTEDataForDisplay(this.sharedData?.summaryData?.mentions),
        method: this.updateRTEDataForDisplay,
        pageCountDivider: this.maxRecordsInOneAPIRes * 2,
        searchTextData: '',
        oldSearchText: '',
        isAllDataLoaded: this.sharedData?.summaryData?.mentions?.length < this.maxRecordsInOneAPIRes ? true : false
      },
      {
        name: "everything",
        tabName: "everything",
        data: this.updateEverythingDataForDisplay(this.sharedData?.summaryData?.everything),
        method: this.updateEverythingDataForDisplay,
        searchTextData: '',
        oldSearchText: '',
        pageCountDivider: this.maxRecordsInOneAPIRes * 4,
        isAllDataLoaded: this.sharedData?.summaryData?.everything?.length < this.maxRecordsInOneAPIRes ? true : false
      },
      {
        name: "posts",
        tabName: "posts",
        data: this.updateRTEDataForDisplay(this.sharedData?.summaryData?.posts),
        method: this.updateRTEDataForDisplay,
        searchTextData: '',
        oldSearchText: '',
        pageCountDivider: this.maxRecordsInOneAPIRes,
        isAllDataLoaded: this.sharedData?.summaryData?.posts?.length < this.maxRecordsInOneAPIRes ? true : false
      },
      {
        name: "files",
        tabName: "files",
        data: this.updateFileDataForDisplay(this.sharedData?.summaryData?.files),
        method: this.updateFileDataForDisplay,
        searchTextData: '',
        oldSearchText: '',
        pageCountDivider: this.maxRecordsInOneAPIRes,
        isAllDataLoaded: this.sharedData?.summaryData?.files?.length < this.maxRecordsInOneAPIRes ? true : false
      },
      {
        name: "comments",
        tabName: "comments",
        data: this.updateRTEDataForDisplay(this.sharedData?.summaryData?.comments),
        method: this.updateRTEDataForDisplay,
        searchTextData: '',
        oldSearchText: '',
        pageCountDivider: this.maxRecordsInOneAPIRes,
        isAllDataLoaded: this.sharedData?.summaryData?.comments?.length < this.maxRecordsInOneAPIRes ? true : false
      }
    ]
  }

  updateRTEDataForDisplay(records: Summary[]) {
    return records?.map((record: Summary) => {
      record.shortDescription = this.extractShortDescription(record.content);
      record.displayContent = this.sanitizer.bypassSecurityTrustHtml(this.extractTextFromHTML(record.content));
      record.imgUrl = this.iconUrlMapper[record.contentType === Summary_Types.MENTION ? record.mentionType?.toLowerCase() : record.contentType.toLowerCase()] ?? 'file';
      return record;
    });
  }

  updateFileDataForDisplay(records: Summary[]) {
    return records?.map((record: Summary) => {
      if ([FileTypes.FOLDER, FileTypes.NOTE].includes(record.kind)) {
        record.imgUrl = this.iconUrlMapper[record.kind];
        let properties = JSON.parse(record.fileProperties);
        record.displayContent = properties?.body ? this.sanitizer.bypassSecurityTrustHtml(this.extractTextFromHTML(properties.Body)) : '';
      }
      else {
        let lastDotIndex = record.fileName.lastIndexOf('.');
        let extension = lastDotIndex === -1 ? record.kind : record.fileName.substring(lastDotIndex + 1);
        record.imgUrl = this.iconUrlMapper[extension] ?? 'file';
      }
      return record;
    });
  }

  updateEverythingDataForDisplay(records: Summary[]) {
    return records?.map((record: Summary) => {
      record.shortDescription = record.contentType === Summary_Types.FILE ? '' : this.extractShortDescription(record.content);
      record.displayContent = record.contentType === Summary_Types.FILE ? '' : this.sanitizer.bypassSecurityTrustHtml(this.extractTextFromHTML(record.content));
      if (record.contentType === Summary_Types.FILE) {
        if ([FileTypes.FOLDER, FileTypes.NOTE].includes(record.kind)) {
          record.imgUrl = this.iconUrlMapper[record.kind];
          let properties = JSON.parse(record.fileProperties);
          record.displayContent = properties?.body ? this.sanitizer.bypassSecurityTrustHtml(this.extractTextFromHTML(properties.Body)) : '';
        }
        else {
          let lastDotIndex = record.fileName.lastIndexOf('.');
          let extension = lastDotIndex === -1 ? record.kind : record.fileName.substring(lastDotIndex + 1);
          record.imgUrl = this.iconUrlMapper[extension] ?? 'file';
        }
      }
      else {
        record.imgUrl = this.iconUrlMapper[record.contentType === Summary_Types.MENTION ? record.mentionType?.toLowerCase() : record.contentType.toLowerCase()] ?? 'file';
      }
      return record;
    });
  }

  extractShortDescription(htmlString: string) {
    const textString = this.extractTextFromHTML(htmlString, 1);
    const atIndex = textString.indexOf('@');
    if (atIndex > 0) {
      const atText = textString.substring(0, atIndex);
      return atText.length <= 100 ? this.sanitizer.bypassSecurityTrustHtml(atText) : null;
    }
    return null;
  }

  extractTextFromHTML(htmlString: string, percent = 0.2): any {
    const sanitizedHTML = htmlString.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
    const text = sanitizedHTML.replace(/<[^>]*>/g, ' ');
    const trimmedText = text.replace(/\s+/g, ' ').trim();
    if (trimmedText.length <= 100) return trimmedText;
    else if (trimmedText.length <= 200) percent = 0.8;
    else if (trimmedText.length <= 400) percent = 0.5;
    const length = Math.floor(trimmedText.length * percent);
    const truncatedText = trimmedText.slice(0, length);
    return truncatedText + '...';
  }

  searchSubmit(selectedTabIndex: number) {
    const newSearchTextFromInput = this.searchText.trim();
    if (this.summaryData[selectedTabIndex].searchTextData === newSearchTextFromInput) {
      return;
    }
    this.summaryData[selectedTabIndex].oldSearchText = this.summaryData[selectedTabIndex].searchTextData;
    this.summaryData[selectedTabIndex].searchTextData = newSearchTextFromInput;
    this.summaryData[selectedTabIndex].isAllDataLoaded = false;
    this.filteredSummaryData = [];
    this.isSummaryDataLoaded = false;
    this.getSpecificTabDataOnDemandScroll(selectedTabIndex, true, false, true);
  }

  tabChanged() {
    this.filteredSummaryData = this.summaryData[this.selectedTabIndex].data;
  }

  handleSummaryItemClick(record: any) {
    record.id = record?.postId ? record.postId : record.id;
    this.sharedDataEvent.emit({
      type: this.screenType,
      action: 'Open Task',
      data: record
    });
  }

  notificationSettings() {
    this.collaborationService.setShowOrHideSideSharedNav('taskSummary', true);
  }

  getSpecificTabDataOnDemandScroll(selectedTabIndex: number, resetData = false, onDemandSCroll = true, fromSearchTetx = false) {
    let tabData = this.summaryData[selectedTabIndex];
    if (tabData.isAllDataLoaded) {
      return;
    }
    if (!onDemandSCroll) {
      this.showLoader = true;
    } else if (onDemandSCroll) {
      this.showOnDemandLoader = true;
    }
    const currentRecords = tabData.data.length && !resetData ? Math.ceil(tabData.data.length / tabData.pageCountDivider) : 0;
    const { tabName, searchTextData } = tabData;
    this.sharedDataEvent.emit({
      type: this.screenType,
      action: 'On Demand Scroll',
      data: {
        currentRecords,
        tabName,
        searchTextData,
        selectedTabIndex,
        fromSearchTetx,
        resetData
      }
    });
  }
}
